<template>
	<el-form :label-position="formData.formStyle.labelPosition"
			 :label-width="formData.formStyle.hideLabel ? '0' : formData.formStyle.labelWidth"
			 :label-suffix="formData.formStyle.labelSuffix"
			 :hide-required-asterisk="!formData.formStyle.showRequiredAsterisk"
			 :show-message="formData.formStyle.showVerificationMessage"
			 :size="formData.formStyle.size"
			 :model="formData.model"
			 :rules="rules"
			 :ref="formRef">
		<slot></slot>
	</el-form>
</template>

<script>
import _ from 'lodash'
import * as ruleApi from './el-rule'

export default {
	name: 'TpFormBox',
	props: {
		formData: {
			type: Object,
			required: true
		}
	},
	data() {
		return {
			rules: {},
			formRef: '',
			el_rules: {
				email: [
					// 邮箱
					{
						required: true,
						message: '请输入正确的邮箱地址',
						trigger: 'blur',
						type: 'email'
					}
				],
				idCard: [
					// 身份证
					{
						required: true,
						validator: ruleApi.idCardValidator,
						message: '',
						trigger: 'blur'
					}
				],
				phone: [
					// 电话-座机 格式0551-65604243
					{
						required: true,
						validator: ruleApi.phoneValidator,
						message: '',
						trigger: 'blur'
					}
				],
				mobilePhone: [
					// 电话-手机
					{
						required: true,
						validator: ruleApi.mobilePhoneValidator,
						message: '',
						trigger: 'blur'
					}
				],
				number: [
					// 数字
					{
						required: true,
						validator: ruleApi.numberPhoneValidator,
						message: '',
						trigger: ['blur', 'change']
					}
				],
				chinese: [
					// 中文
					{
						required: true,
						validator: ruleApi.chineseValidator,
						message: '',
						trigger: ['blur', 'change']
					}
				],
				english: [
					// 英文
					{
						required: true,
						validator: ruleApi.englishValidator,
						message: '',
						trigger: ['blur', 'change']
					}
				],
				url: [
					// url
					{
						required: true,
						validator: ruleApi.urlValidator,
						message: '',
						trigger: 'blur'
					}
				],
				upper: [
					// 大写
					{
						required: true,
						validator: ruleApi.upperValidator,
						message: '',
						trigger: ['blur', 'change']
					}
				],
				lower: [
					// 小写
					{
						required: true,
						validator: ruleApi.lowerValidator,
						message: '',
						trigger: ['blur', 'change']
					}
				],
				pwd: [
					// 密码以字母开头，长度在6~18之间，只能包含字母、数字和下划线
					{
						required: true,
						validator: ruleApi.pwdValidator,
						message: '',
						trigger: 'blur'
					}
				],
				postal: [
					// 邮政编码
					{
						required: true,
						validator: ruleApi.postalValidator,
						message: '',
						trigger: 'blur'
					}
				],
				minMax: [
					// 数字区间
					{
						required: true,
						validator: ruleApi.minMaxValidator,
						message: '',
						trigger: 'blur',
						min: 0,
						max: 0
					}
				],
				length: [
					// 字符长度
					{
						required: true,
						validator: ruleApi.lengthValidator,
						message: '',
						trigger: 'blur',
						length: 0
					}
				]
			}
		}	
	},
	methods: {
		doRules(li) {
			Object.keys(li.rules || {}).forEach(ruleKey => {
				if (ruleKey === 'regx') {
					li.rules[ruleKey].validator = function(
						rule,
						value,
						callback
					) {
						if (!new RegExp(rule.regx).test(value)) {
							callback(new Error(rule.message))
						} else {
							callback()
						}
					}
				}
				if (this.rules[li.fieldId]) {
					this.rules[li.fieldId].concat(li.rules[ruleKey])
				} else {
					if (li.rule && li.rule.length > 0) {
						this.rules[li.fieldId] = [].concat(this.el_rules[li.rule])
					} else {
						this.rules[li.fieldId] = [].concat(li.rules[ruleKey])
					}
				}
			})

			// console.log(this.rules)
		},

		// 验证表单
		validateForm() {
			let res = ''
			this.$refs[this.formRef].validate(valid => {
				res = valid
			})
			return res
		}
	},
	created() {
		this.formRef = new Date().getTime()

		this.formData.formDataList &&
			this.formData.formDataList.forEach(li => {
				if (li.name === 'Layout') {
					li.setting.colList.forEach(col => {
						col && this.doRules(col)
					})
				} else {
					this.doRules(li)
				}
			})
	}
}
</script>